import { Suspense } from "react";
import { public_routes, private_routes } from "routes";
import CircleLoader from "components/atoms/CircleLoader";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { useAppSelector } from "redux/hooks";
export default function AppRoutes() {
  const user = useAppSelector((state) => state.auth.user);

  return (
    <div style={{ minHeight: "90vh", position: "relative" }}>
      <Suspense fallback={<CircleLoader />}>
        <Routes>
          {public_routes.map(({ path, element }, i) => (
            <Route key={i} path={path} element={element} />
          ))}

          {private_routes(user?.role).map(({ path, element }, i) => (
            <Route
              key={i}
              path={path}
              element={<PrivateRoute>{element}</PrivateRoute>}
            />
          ))}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </div>
  );
}
